<script setup lang="ts">
/**
 * FW-145 — 01-giris-eposta'nin "Fusapp'a yeni misiniz?" ayraci + deneme
 * kartı (design/current/Auth v2.dc.html satir 110-114). Yalniz e-posta
 * adiminda gorunur; parola/secim/tamam adimlarinda tasarimda hic yok.
 *
 * FW-129 — kayit akisi ARTIK VAR (/register, RegisterIdentityView.vue);
 * kart eskiden BILEREK devre disi (`<button disabled>`) render ediliyordu
 * ("calismayan bir akisi vaat etme" kurali). O kural burada TERSINE isliyor:
 * akis calisir hale geldiginde disabled birakmak "calisan bir akisi VAAT
 * ETMEMEK" hatasina duserdi — auth view bu kartin register olayini GERCEK bir router.push ile
 * '/register'e baglar (bkz. AuthTrialPrompt.spec.ts'teki mutasyon kaniti:
 * bu baglanti kaldirilinca test KIRMIZI doner).
 */
// FW-224 — gezinme auth view'da kalir; Console'a musteri kaydi tasinmaz.
defineProps<{ divider: string; title: string; subtitle: string }>()
defineEmits<{ register: [] }>()
</script>

<template>
  <div
    class="fw-auth-trial"
    data-testid="auth-trial-prompt"
  >
    <div
      class="fw-auth-trial__divider"
      role="separator"
    >
      <span class="fw-auth-trial__divider-line" />
      <span class="fw-auth-trial__divider-label">{{ divider }}</span>
      <span class="fw-auth-trial__divider-line" />
    </div>
    <button
      type="button"
      class="fw-auth-trial__card"
      data-testid="auth-trial-card"
      @click="$emit('register')"
    >
      <span class="fw-auth-trial__card-copy">
        <span class="fw-auth-trial__card-title">{{ title }}</span>
        <span class="fw-auth-trial__card-subtitle">{{ subtitle }}</span>
      </span>
      <span
        class="fw-auth-trial__card-chevron"
        aria-hidden="true"
      >›</span>
    </button>
  </div>
</template>

<style scoped>
.fw-auth-trial {
  margin-top: 26px;
}

.fw-auth-trial__divider {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 18px;
}

.fw-auth-trial__divider-line {
  flex: 1;
  height: 1px;
  background: var(--fw-border);
}

.fw-auth-trial__divider-label {
  font-size: 12px;
  color: var(--fw-text-muted);
  white-space: nowrap;
}

.fw-auth-trial__card {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 9px;
  border: 1px solid var(--fw-border);
  background: var(--fw-bg-surface);
  text-align: left;
}

.fw-auth-trial__card-copy {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.fw-auth-trial__card-title {
  font-size: 14px;
  font-weight: 600;
  color: var(--fw-text-primary);
}

.fw-auth-trial__card-subtitle {
  font-size: 12px;
  color: var(--fw-text-secondary);
  margin-top: 2px;
}

.fw-auth-trial__card-chevron {
  color: var(--fw-text-secondary);
}
</style>
